const SendTemplateWarning: React.FC<{
    openIsCopyToSendTemplate: () => void;
    closeShowDigitalRxWarning: () => void;
}> = ({ openIsCopyToSendTemplate, closeShowDigitalRxWarning }) => {
    return (
        <div
            style={{
                backdropFilter: 'blur(10px)',
            }}
            className="absolute inset-0 flex flex-col items-center justify-center space-y-36 w-full h-full p-16 z-20"
        >
            <div className="flex flex-col items-center space-y-10">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 36 36"
                    fill="none"
                    className="w-36 h-36"
                >
                    <path
                        d="M25.3125 10.5938C27.2812 12.5625 28.5 15.1406 28.5 17.9531C28.5 23.6719 23.7188 28.3594 17.9531 28.3594C16.2188 28.3594 14.5312 27.8906 12.9844 27.0938L7.5 28.5L8.95312 23.1094C8.0625 21.5625 7.54688 19.7812 7.54688 17.9062C7.54688 12.1875 12.2344 7.5 17.9531 7.5C20.7656 7.5 23.3906 8.625 25.3125 10.5938ZM17.9531 26.5781C22.7344 26.5781 26.7188 22.6875 26.7188 17.9531C26.7188 15.6094 25.7344 13.4531 24.0938 11.8125C22.4531 10.1719 20.2969 9.28125 18 9.28125C13.2188 9.28125 9.32812 13.1719 9.32812 17.9062C9.32812 19.5469 9.79688 21.1406 10.6406 22.5469L10.875 22.875L9.98438 26.0625L13.2656 25.1719L13.5469 25.3594C14.9062 26.1562 16.4062 26.5781 17.9531 26.5781ZM22.7344 20.1094C22.9688 20.25 23.1562 20.2969 23.2031 20.4375C23.2969 20.5312 23.2969 21.0469 23.0625 21.6562C22.8281 22.2656 21.7969 22.8281 21.3281 22.875C20.4844 23.0156 19.8281 22.9688 18.1875 22.2188C15.5625 21.0938 13.875 18.4688 13.7344 18.3281C13.5938 18.1406 12.7031 16.9219 12.7031 15.6094C12.7031 14.3438 13.3594 13.7344 13.5938 13.4531C13.8281 13.1719 14.1094 13.125 14.2969 13.125C14.4375 13.125 14.625 13.125 14.7656 13.125C14.9531 13.125 15.1406 13.0781 15.375 13.5938C15.5625 14.1094 16.125 15.375 16.1719 15.5156C16.2188 15.6562 16.2656 15.7969 16.1719 15.9844C15.7031 16.9688 15.1406 16.9219 15.4219 17.3906C16.4531 19.125 17.4375 19.7344 18.9844 20.4844C19.2188 20.625 19.3594 20.5781 19.5469 20.4375C19.6875 20.25 20.2031 19.6406 20.3438 19.4062C20.5312 19.125 20.7188 19.1719 20.9531 19.2656C21.1875 19.3594 22.4531 19.9688 22.7344 20.1094Z"
                        fill="#19A66A"
                    />
                </svg>

                <span className="text-darwin-neutral-1000 text-20">
                    Now send Rx digitally via WhatsApp
                </span>
                <span className="text-darwin-neutral-1000 text-14">Here is your Rx will look.</span>
            </div>

            <div className="flex flex-col items-center space-y-10">
                <button onClick={openIsCopyToSendTemplate}>
                    <span className="flex items-center space-x-4">
                        <span>
                            <svg
                                className="w-15 h-15 fill-darwin-accent-bright-blue-800"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                            >
                                <path d="M502.6 70.63l-61.25-61.25C435.4 3.371 427.2 0 418.7 0H255.1c-35.35 0-64 28.66-64 64l.0195 256C192 355.4 220.7 384 256 384h192c35.2 0 64-28.8 64-64V93.25C512 84.77 508.6 76.63 502.6 70.63zM464 320c0 8.836-7.164 16-16 16H255.1c-8.838 0-16-7.164-16-16L239.1 64.13c0-8.836 7.164-16 16-16h128L384 96c0 17.67 14.33 32 32 32h47.1V320zM272 448c0 8.836-7.164 16-16 16H63.1c-8.838 0-16-7.164-16-16L47.98 192.1c0-8.836 7.164-16 16-16H160V128H63.99c-35.35 0-64 28.65-64 64l.0098 256C.002 483.3 28.66 512 64 512h192c35.2 0 64-28.8 64-64v-32h-47.1L272 448z"></path>
                            </svg>
                        </span>
                        <span className="text-darwin-accent-bright-blue-800 text-14 font-700">
                            Copy from Print Rx Template
                        </span>
                    </span>
                </button>
                <span className="text-darwin-neutrals-600">OR</span>
                <button onClick={closeShowDigitalRxWarning}>
                    <span className="flex items-center space-x-4">
                        <span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 13 13"
                                className="w-15 h-15 fill-darwin-accent-bright-blue-800"
                            >
                                <path d="M12.0752 1.83594L11.1846 0.945312C10.9033 0.664062 10.5049 0.5 10.1299 0.5C9.75488 0.5 9.35645 0.664062 9.0752 0.945312L1.24707 8.77344C1.17676 8.82031 1.15332 8.89062 1.12988 8.96094L0.520508 12.0312C0.473633 12.2891 0.661133 12.5 0.87207 12.5C0.895508 12.5 0.942383 12.5 0.96582 12.5L4.03613 11.8906C4.10645 11.8672 4.17676 11.8438 4.24707 11.7734L12.0752 3.94531C12.6611 3.35938 12.6611 2.42188 12.0752 1.83594ZM3.59082 10.8359L1.83301 11.1875L2.18457 9.42969L2.77051 8.84375V10.25H4.17676L3.59082 10.8359ZM3.89551 9.125V7.71875L8.02051 3.59375L9.4502 5L5.30176 9.125H3.89551Z"></path>
                            </svg>
                        </span>
                        <span className="text-darwin-accent-bright-blue-800 text-14 font-700">
                            Edit digital template
                        </span>
                    </span>
                </button>
            </div>
            <div className="border border-darwin-accent-investigations-ochre-800 bg-darwin-accent-investigations-ochre-100 px-8 py-10 space-x-6 rounded-8 flex">
                <span className="pt-3 pl-2">
                    <svg
                        className="w-16 h-16 fill-darwin-accent-investigations-ochre-800"
                        viewBox="0 0 14 15"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M7 14.75C10.8555 14.75 14 11.6328 14 7.75C14 3.89453 10.8555 0.75 7 0.75C3.11719 0.75 0 3.89453 0 7.75C0 11.6328 3.11719 14.75 7 14.75ZM7 4.25C7.35547 4.25 7.65625 4.55078 7.65625 4.90625V7.96875C7.65625 8.35156 7.35547 8.625 7 8.625C6.61719 8.625 6.34375 8.35156 6.34375 7.96875V4.90625C6.34375 4.55078 6.61719 4.25 7 4.25ZM7.875 10.375C7.875 10.8672 7.46484 11.25 7 11.25C6.50781 11.25 6.125 10.8672 6.125 10.375C6.125 9.91016 6.50781 9.5 7 9.5C7.46484 9.5 7.875 9.91016 7.875 10.375Z"></path>
                    </svg>
                </span>
                <span className="text-13">
                    We recommend you not to edit this as it might lead to improper Rx in certain
                    cases!
                </span>
            </div>
        </div>
    );
};

export default SendTemplateWarning;
